// Runtime configuration loader
// This loads configuration from the window object that's populated by config.js

interface RuntimeConfig {
    auth0: {
        domain: string;
        clientId: string;
        audience: string;
    };
    api: {
        accessApiUrl: string;
        managementApiUrl: string;
    };
    customerAppDomain?: string;
}

declare global {
    interface Window {
        APP_CONFIG?: RuntimeConfig;
    }
}

// Get runtime config from window object
const getRuntimeConfig = (): RuntimeConfig => {
    // Check if config exists on window
    if (typeof window !== 'undefined' && window.APP_CONFIG) {
        return window.APP_CONFIG;
    }

    // Fallback to build-time env vars for local development
    return {
        auth0: {
            domain: import.meta.env.VITE_AUTH0_DOMAIN || '',
            clientId: import.meta.env.VITE_AUTH0_CLIENT_ID || '',
            audience: import.meta.env.VITE_AUTH0_AUDIENCE || '',
        },
        api: {
            accessApiUrl: import.meta.env.VITE_ACCESS_API_URL || '',
            managementApiUrl: import.meta.env.VITE_MANAGEMENT_API_URL || '',
        },
        customerAppDomain: import.meta.env.VITE_CUSTOMER_APP_DOMAIN || '',
    };
};

export const runtimeConfig = getRuntimeConfig();
